module.exports = __webpack_public_path__ + "img/15.9025bf1b.jpg";